import { Component, Input } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { TeamNavigationService } from '../../services/team-navigation.service';

@Component({
    selector: 'app-team-approval-requests',
    templateUrl: './team-approval-requests.component.html',
    styleUrls: ['./team-approval-requests.component.scss'],
})
export class TeamApprovalRequestsComponent {
    @Input()
    approvalRequestsTeamOverview: { inProgressRequests: number };

    @Input()
    teamId: string;

    @Input()
    teamMemberId: string;

    constructor(private _store: Store, private _teamNavigationService: TeamNavigationService) {}

    openApprovalRequestTeamRequestsPage(): void {
        this._teamNavigationService.addTeamPath(window.location.pathname);
        this._store.dispatch(new Navigate([`my-teams/team/${this.teamId}/${this.teamMemberId ? 'member/' + this.teamMemberId + '/' : ''}team-requests`]));
    }
}
